"use strict";
exports.__esModule = true;
exports.MenuSection = void 0;
var MenuSection;
(function (MenuSection) {
    MenuSection["Restaurant"] = "restaurant";
    MenuSection["Bar"] = "bar";
    MenuSection["Wine"] = "wine";
    MenuSection["AsianFood"] = "asianFood";
    MenuSection["Sushi"] = "sushi";
    MenuSection["Deserts"] = "deserts";
    MenuSection["Terrace"] = "terrace";
    MenuSection["Extra"] = "extra";
})(MenuSection = exports.MenuSection || (exports.MenuSection = {}));
